<!--培育申报-->
<template>
  <div class="fill-container">
    <header-index/>
    <div class="fill-content">
      <div class="fill-breadcrumb">
        <span>您当前位置:</span>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item
              :to="{ path: '/cloudPlatform/platform?city=2&cityName='+childNode.name+'&cityCode='+childNode.cityCode+'&parentCityCode='+childNode.parentCityCode+'&pName='+childNode.name+'企业数字化服务云平台&parName=渝企服务云' }">
            服务平台
          </el-breadcrumb-item>
          <el-breadcrumb-item
              :to="{ path: '/cultivation/index?city=2&cityName='+childNode.name+'&cityCode='+childNode.cityCode+'&parentCityCode='+childNode.parentCityCode+'&pName='+childNode.name+'企业数字化服务云平台&parName=渝企服务云' }">
            企业培育
          </el-breadcrumb-item>
          <el-breadcrumb-item>{{ fillType }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="fill-info">
        <p class="fill-title">培育申报</p>
        <el-tabs v-model="activeName" type="card" :stretch="true"><!-- :before-leave="leaveBefore"-->
          <el-tab-pane label="基本信息" name="first" disabled/>
          <el-tab-pane label="经营信息" name="second" disabled/>
          <el-tab-pane label="项目研发信息" name="third" disabled/>
          <el-tab-pane label="技术成果信息" name="fourth" disabled/>
        </el-tabs>
        <div class="fill-form">
          <!--基本信息-->
          <div class="basic-form-container" v-show="activeName=='first'">
            <el-form :model="basicForm" :rules="basicRules" label-position="right" ref="basicForm0" class="basicForm0">
              <el-form :inline="true" class="demo-form-inline" :rules="basicRules" :model="basicForm" ref="basicForm1"
                       label-position="right">
                <el-form-item label="企业名称:" prop="companyName" label-width="120px">
                  <el-input v-model="basicForm.companyName" :style="'width:'+inputWidth+'px;'"/>
                </el-form-item>
                <el-form-item label="统一社会信用代码:" prop="unifiedSocialCreditCode">
                  <el-input v-model="basicForm.unifiedSocialCreditCode" :style="'width:'+inputWidth+'px;'"/>
                </el-form-item>
              </el-form>
              <el-form :inline="true" class="demo-form-inline" :rules="basicRules" :model="basicForm" ref="basicForm2"
                       label-position="right">
                <el-form-item label="法定代表人:" prop="legalPerson" label-width="120px">
                  <el-input v-model="basicForm.legalPerson" :style="'width:'+inputWidth+'px;'"/>
                </el-form-item>
                <el-form-item label="法人电话:" prop="legalPhone">
                  <el-input v-model="basicForm.legalPhone" :style="'width:'+inputWidth+'px;'"/>
                </el-form-item>
              </el-form>
              <el-form :inline="true" class="demo-form-inline" :rules="basicRules" :model="basicForm" ref="basicForm3"
                       label-position="right">
                <el-form-item label="登记注册类型:" prop="registerType" label-width="120px">
                  <el-select v-model="basicForm.registerType" placeholder="请选择" clearable :style="'width:'+inputWidth+'px;'">
                    <el-option v-for="item in registerTypeItem" :label="item.dictLabel" :value="item.dictValue"/>
                  </el-select>
                </el-form-item>
                <el-form-item label="经营行业:" prop="industry">
                  <el-cascader v-model="basicForm.industry" :options="industryList" placeholder="请选择" clearable
                               :style="'width:'+inputWidth+'px;'"/>
                </el-form-item>
              </el-form>
              <el-form :inline="true" class="demo-form-inline" :rules="basicRules" :model="basicForm" ref="basicForm4"
                       label-position="right">
                <el-form-item label="注册时间:" prop="registerTime" label-width="120px">
                  <el-date-picker v-model="basicForm.registerTime" value-format="yyyy-MM-dd" placeholder="请选择" type="date"
                                  :style="'width:'+inputWidth+'px;'"/>
                </el-form-item>
                <el-form-item label="注册资金(万元):" prop="registerMoney">
                  <el-input v-model="basicForm.registerMoney" :style="'width:'+inputWidth+'px;'"/>
                </el-form-item>
              </el-form>
              <el-form :inline="true" class="demo-form-inline" :rules="basicRules" :model="basicForm" ref="basicForm5"
                       label-position="right">
                <el-form-item label="单位所在地:" prop="address" label-width="120px">
                  <el-cascader v-model="basicForm.address" :options="provincialCode" @change="handleChange"
                               :style="'width:'+inputWidth+'px;'"/>
                </el-form-item>
                <el-form-item label="单位详细地址:" prop="specificAddress">
                  <el-input v-model="basicForm.specificAddress" :style="'width:'+inputWidth+'px;'"/>
                </el-form-item>
              </el-form>
              <el-form-item label="控股情况:" label-width="120px">
                <el-radio-group v-model="basicForm.hold">
                  <el-radio v-for="hold of holdType" :label="hold" :value="hold"/>
                </el-radio-group>
              </el-form-item>
              <el-form :inline="true" class="demo-form-inline" :rules="basicRules" :model="basicForm" ref="basicForm6"
                       label-position="right">
                <el-form-item label="联系人:" prop="contactPerson" label-width="120px">
                  <el-input v-model="basicForm.contactPerson" :style="'width:'+inputWidth+'px;'"/>
                </el-form-item>
                <el-form-item label="联系人电话:" prop="contactPersonPhone">
                  <el-input v-model="basicForm.contactPersonPhone" :style="'width:'+inputWidth+'px;'"/>
                </el-form-item>
              </el-form>
              <el-form-item label="办公电话:"  prop="contactOfficePhone" label-width="120px">
                <el-input v-model="basicForm.contactOfficePhone" :style="'width:'+inputWidth+'px;'"/>
              </el-form-item>
              <el-form-item style="text-align: center">
                <el-button type="primary" @click="submitBasic">下一步</el-button>
              </el-form-item>
            </el-form>
          </div>
          <!--经营信息-->
          <div class="business-form-container" :style="'min-height:'+min_height+'px;'" v-show="activeName=='second'">
            <el-form :model="businessForm" :rules="businessRules" label-width="175px" label-position="right" ref="businessForm"
                     class="businessForm">
              <el-form-item label="上年度营业收入(万元):" prop="profit">
                <el-input v-model="businessForm.profit"/>
              </el-form-item>
              <el-form-item label="年纳税总额(万元）:" prop="payTaxes">
                <el-input v-model="businessForm.payTaxes"/>
              </el-form-item>
              <el-form-item label="资产总额(万元）:" prop="assets">
                <el-input v-model="businessForm.assets"/>
              </el-form-item>
              <el-form-item label="负债总额(万元）:" prop="liabilities">
                <el-input v-model="businessForm.liabilities"/>
              </el-form-item>
              <el-form-item label="新产品销售收入(万元）:" prop="sellIncome">
                <el-input v-model="businessForm.sellIncome"/>
              </el-form-item>
              <el-form-item label="是否为高新技术企业:" prop="highTechEnterprise">
                <el-radio-group v-model="businessForm.highTechEnterprise">
                  <el-radio :label="'是'">是</el-radio>
                  <el-radio :label="'否'">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item style="text-align: center">
                <el-button type="primary" @click="prevStep(1)">上一步</el-button>
                <el-button type="primary" @click="submitBusiness">下一步</el-button>
              </el-form-item>
            </el-form>
          </div>
          <!--项目研发信息-->
          <div class="research-form-container" :style="'min-height:'+min_height+'px;'" v-show="activeName=='third'">
            <el-form :model="researchForm" :rules="researchRules" label-width="175px" label-position="right" ref="researchForm0"
                     class="researchForm">
              <el-form :inline="true" class="demo-form-inline" :rules="researchRules" :model="researchForm" ref="researchForm1"
                       label-position="right" label-width="185px">
                <el-form-item label="研发产品总数:" prop="product">
                  <el-input v-model="researchForm.product" :style="'width:'+inputWidth+'px;'"/>
                </el-form-item>
                <el-form-item label="企业产品技术水平:" prop="technicalLevel">
                  <el-radio-group v-model="researchForm.technicalLevel">
                    <el-radio v-for="item of technicalLevelList" :label="item">{{ item }}</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-form>
              <el-form :inline="true" class="demo-form-inline" :rules="researchRules" :model="researchForm" ref="researchForm2"
                       label-position="right" label-width="185px">
                <el-form-item label="职工总人数:" prop="workers">
                  <el-input v-model="researchForm.workers" :style="'width:'+inputWidth+'px;'"/>
                </el-form-item>
                <el-form-item label="大专学历人数:" prop="junior_education">
                  <el-input v-model="researchForm.junior_education" :style="'width:'+inputWidth+'px;'"/>
                </el-form-item>
              </el-form>
              <el-form :inline="true" class="demo-form-inline" :rules="researchRules" :model="researchForm" ref="researchForm3"
                       label-position="right" label-width="185px">
                <el-form-item label="本科学历人数:" prop="undergraduate">
                  <el-input v-model="researchForm.undergraduate" :style="'width:'+inputWidth+'px;'"/>
                </el-form-item>
                <el-form-item label="硕士学历人数:" prop="master">
                  <el-input v-model="researchForm.master" :style="'width:'+inputWidth+'px;'"/>
                </el-form-item>
              </el-form>
              <el-form :inline="true" class="demo-form-inline" :rules="researchRules" :model="researchForm" ref="researchForm4"
                       label-position="right" label-width="185px">
                <el-form-item label="博士学历人数:" prop="doctor">
                  <el-input v-model="researchForm.doctor" :style="'width:'+inputWidth+'px;'"/>
                </el-form-item>
              </el-form>
              <el-form :inline="true" class="demo-form-inline" :rules="researchRules" :model="researchForm" ref="researchForm5"
                       label-position="right" label-width="185px">
                <el-form-item label="研发高级职称技术人员数:" prop="senior">
                  <el-input v-model="researchForm.senior" :style="'width:'+inputWidth+'px;'"/>
                </el-form-item>
                <el-form-item label="研发中级职称技术人员数:" prop="intermediate">
                  <el-input v-model="researchForm.intermediate" :style="'width:'+inputWidth+'px;'"/>
                </el-form-item>
              </el-form>
              <el-form :inline="true" class="demo-form-inline" :rules="researchRules" :model="researchForm" ref="researchForm6"
                       label-position="right" label-width="185px">
                <el-form-item label="研发初级职称技术人员数:" prop="primary">
                  <el-input v-model="researchForm.primary" :style="'width:'+inputWidth+'px;'"/>
                </el-form-item>
                <el-form-item label="外籍技术人员数:" prop="foreignNationality">
                  <el-input v-model="researchForm.foreignNationality" :style="'width:'+inputWidth+'px;'"/>
                </el-form-item>
              </el-form>
              <el-form :inline="true" class="demo-form-inline" :rules="researchRules" :model="researchForm" ref="researchForm7"
                       label-position="right" label-width="185px">
                <el-form-item label="研发机构占地面积(㎡):" prop="areaCovered">
                  <el-input v-model="researchForm.areaCovered" :style="'width:'+inputWidth+'px;'"/>
                </el-form-item>
                <el-form-item label="研发技术人员总数:" prop="artisanTotal">
                  <el-input v-model="researchForm.artisanTotal" :style="'width:'+inputWidth+'px;'"/>
                </el-form-item>
              </el-form>
              <el-form-item style="text-align: center;padding-bottom: 20px">
                <el-button type="primary" @click="prevStep(2)">上一步</el-button>
                <el-button type="primary" @click="submitResearch">下一步</el-button>
              </el-form-item>
            </el-form>
          </div>
          <!--技术成果信息-->
          <div class="technological-form-container" :style="'min-height:'+min_height+'px;'" v-show="activeName=='fourth'">
            <el-form :model="technologicalForm" :rules="technologicalRules" label-width="195px" label-position="right" ref="technologicalForm"
                     class="technologicalForm">
              <el-form-item label="有效专利数:" prop="patent_size">
                <el-input v-model="technologicalForm.patent_size" :style="'width:'+inputWidth+'px;'"/>
              </el-form-item>
              <el-form-item label="专利产品数:" prop="patent_total">
                <el-input v-model="technologicalForm.patent_total" :style="'width:'+inputWidth+'px;'"/>
              </el-form-item>
              <el-form-item label="有效软著数:" prop="softening_size">
                <el-input v-model="technologicalForm.softening_size" :style="'width:'+inputWidth+'px;'"/>
              </el-form-item>
              <el-form-item label="有效商标数:" prop="trademark_size">
                <el-input v-model="technologicalForm.trademark_size" :style="'width:'+inputWidth+'px;'"/>
              </el-form-item>
              <el-form-item label="专利产品年销售收入(万元):" prop="revenue">
                <el-input v-model="technologicalForm.revenue" :style="'width:'+inputWidth+'px;'"/>
              </el-form-item>
              <el-form-item  label-width="50px">
                <label class="is-red-label">技术成果包括：商标、标准、动植物新品种、原产地保护产品、计算机软件著作权、经认定的科技成果或其他专有技术等。</label>
              </el-form-item>
              <el-form-item label="技术成果国家级（个）:" prop="municipal_level">
                <el-input v-model="technologicalForm.municipal_level" :style="'width:'+inputWidth+'px;'"/>
              </el-form-item>
              <el-form-item label="技术成果省市级（个）:" prop="nationalLevel">
                <el-input v-model="technologicalForm.nationalLevel" :style="'width:'+inputWidth+'px;'"/>
              </el-form-item>
              <el-form-item style="text-align: center">
                <el-button type="primary" @click="prevStep(3)">上一步</el-button>
                <el-button type="danger" @click="submitTechnological">申请入库</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <home_footer/>
    <Hang/>
  </div>
</template>
<script>
import headerIndex from "@/components/header/headerIndex";
import home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hang";
import provincialCode from "@/static/area.json";
import {pyfdAppOperatingIndustry, pyfdAppRegistrationType,pyfdAppKeyPolicyWarehousing} from "@/api/pySystemApi";
import {isMobile, isMoney, isPositiveInteger} from "@/common/tools";
export default {
  name: "fillGrowth",
  components: {headerIndex, home_footer, Hang},
  data() {
    const checkPhone = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('请输入法人电话'));
      } else if (!isMobile(value)) {
        callback(new Error('请输入正确的手机号'));
      } else {
        callback();
      }
    }
    const checkMoney = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('注册资金不能为空'));
      } else if (!isMoney(value)) {
        callback(new Error('请输入合法的金额数字，最多两位小数'));
      } else {
        callback();
      }
    }
    const checkMoney6 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入营业收入'));
      } else if (!isMoney(value)) {
        callback(new Error('请输入合法的金额数字，最多两位小数'));
      } else {
        callback();
      }
    }
    const checkMoney2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入年纳税总额'));
      } else if (!isMoney(value)) {
        callback(new Error('请输入合法的金额数字，最多两位小数'));
      } else {
        callback();
      }
    }
    const checkMoney3 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入资产总额'));
      } else if (!isMoney(value)) {
        callback(new Error('请输入合法的金额数字，最多两位小数'));
      } else {
        callback();
      }
    }
    const checkMoney4 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入负债总额'));
      } else if (!isMoney(value)) {
        callback(new Error('请输入合法的金额数字，最多两位小数'));
      } else {
        callback();
      }
    }
    const checkMoney5 = (rule, value, callback) => {
      if (value === '') {
        callback();
      } else if (!isMoney(value)) {
        callback(new Error('请输入合法的金额数字，最多两位小数'));
      } else {
        callback();
      }
    }
    const PositiveInteger = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写研发产品总数'));
      } else if (!isPositiveInteger(value)) {
        callback(new Error('请输入正整数'));
      } else {
        callback();
      }
    }
    const PositiveInteger2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写职工总人数'));
      } else if (!isPositiveInteger(value)) {
        callback(new Error('请输入正整数'));
      } else {
        callback();
      }
    }
    const PositiveInteger3 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写大专学历人数'));
      } else if (!isPositiveInteger(value)) {
        callback(new Error('请输入正整数'));
      } else {
        callback();
      }
    }
    const PositiveInteger4 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写本科学历人数'));
      } else if (!isPositiveInteger(value)) {
        callback(new Error('请输入正整数'));
      } else {
        callback();
      }
    }
    const PositiveInteger5 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写硕士学历人数'));
      } else if (!isPositiveInteger(value)) {
        callback(new Error('请输入正整数'));
      } else {
        callback();
      }
    }
    const PositiveInteger6 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写博士学历人数'));
      } else if (!isPositiveInteger(value)) {
        callback(new Error('请输入正整数'));
      } else {
        callback();
      }
    }
    const PositiveInteger7 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写研发高级职称技术人员数'));
      } else if (!isPositiveInteger(value)) {
        callback(new Error('请输入正整数'));
      } else {
        callback();
      }
    }
    const PositiveInteger8 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写研发中级职称技术人员数'));
      } else if (!isPositiveInteger(value)) {
        callback(new Error('请输入正整数'));
      } else {
        callback();
      }
    }
    const PositiveInteger9 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写研发初级职称技术人员数'));
      } else if (!isPositiveInteger(value)) {
        callback(new Error('请输入正整数'));
      } else {
        callback();
      }
    }
    const PositiveInteger10 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写研发技术人员总数'));
      } else if (!isPositiveInteger(value)) {
        callback(new Error('请输入正整数'));
      } else {
        callback();
      }
    }
    const PositiveInteger11 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写博士学历人数'));
      } else if (!isPositiveInteger(value)) {
        callback(new Error('请输入正整数'));
      } else {
        callback();
      }
    }
    const PositiveFloat= (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写研发机构占地面积'));
      } else if (!isMoney(value)) {
        callback(new Error('输入的数字不合法'));
      } else {
        callback();
      }
    }
    const PositiveInteger12 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写有效专利数'));
      } else if (!isPositiveInteger(value)) {
        callback(new Error('请输入正整数'));
      } else {
        callback();
      }
    }
    const PositiveInteger13 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写专利产品数'));
      } else if (!isPositiveInteger(value)) {
        callback(new Error('请输入正整数'));
      } else {
        callback();
      }
    }
    const PositiveInteger14 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写有效软著数'));
      } else if (!isPositiveInteger(value)) {
        callback(new Error('请输入正整数'));
      } else {
        callback();
      }
    }
    const PositiveInteger15 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写有效商标数'));
      } else if (!isPositiveInteger(value)) {
        callback(new Error('请输入正整数'));
      } else {
        callback();
      }
    }
    const PositiveInteger16 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写技术成果国家级数量'));
      } else if (!isPositiveInteger(value)) {
        callback(new Error('请输入正整数'));
      } else {
        callback();
      }
    }
    const PositiveInteger17 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写技术成果省市级数量'));
      } else if (!isPositiveInteger(value)) {
        callback(new Error('请输入正整数'));
      } else {
        callback();
      }
    }
    return {
      fillType:'',
      min_height: document.documentElement.clientHeight - 416,
      childNode: {},
      cid: 0,
      pName: '',
      leave:0,
      activeName:'first',
      systemType:'',
      /*基本信息*/
      basicForm: {
        companyName: '',
        unifiedSocialCreditCode: '',
        legalPerson: '',
        legalPhone: '',
        registerType: '',
        industry: [],
        registerTime: '',
        registerMoney: '',
        address: '',
        specificAddress: '',
        province: '',
        city: '',
        district: '',
        provinceName: '',
        cityName: '',
        districtName: '',
        hold: '',
      },
      inputWidth: 'auto',
      inputWidth2: 'auto',
      registerTypeItem: [],
      industryList: [],
      provincialCode: provincialCode,
      holdType: ['国有控股', '集体控股', '私人控股', '港澳台控股', '外商控股'],
      basicRules: {
        companyName: [
          {required: true, message: '请输入企业名称', trigger: 'blur'},
          {min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur'}
        ],
        unifiedSocialCreditCode: [
          {required: true, message: '请填写统一社会信用代码', trigger: 'blur'}
        ],
        legalPerson: [
          {required: true, message: '请输入法定代表人', trigger: 'blur'}
        ],
        legalPhone: [
          {required: true, validator: checkPhone, trigger: 'blur'}
        ],
        registerType: [
          {required: true, message: '请选择登记注册类型', trigger: 'change'}
        ],
        registerTime: [
          {required: true, message: '请选择注册时间', trigger: 'change'}
        ],
        registerMoney: [
          {required: true, validator: checkMoney, trigger: 'blur'}
        ],
        address: [
          {required: true, message: '请填写单位所在地', trigger: 'blur'}
        ],
        specificAddress: [
          {required: true, message: '请填写单位详细地址', trigger: 'blur'}
        ],
        contactPerson: [
          {required: true, message: '请填写联系人', trigger: 'blur'}
        ],
        contactPersonPhone: [
          {required: true, message: '请填写联系人电话', trigger: 'blur'}
        ],
        contactOfficePhone: [
          {required: true, message: '请填写办公电话', trigger: 'blur'}
        ],
        industry:[
          {required: true, message: '请选择经营行业', trigger: 'change'}
        ]
      },
      /*经营信息*/
      businessForm: {
        profit:'',
        payTaxes:'',
        assets:'',
        liabilities:'',
        highTechEnterprise:'',
        sellIncome:'',
      },
      businessRules: {
        profit:[
          {required: true, validator: checkMoney6, trigger: 'blur'}
        ],
        payTaxes:[
          {required: true, validator: checkMoney2, trigger: 'blur'}
        ],
        assets:[
          {required: true, validator: checkMoney3, trigger: 'blur'}
        ],
        liabilities:[
          {required: true, validator: checkMoney4, trigger: 'blur'}
        ],
        highTechEnterprise:[
          {required: true, message: '请选择是否为高新技术企业', trigger: 'blur'}
        ],
        sellIncome:[
          {validator: checkMoney5, trigger: 'blur'}
        ]
      },
      /*项目研发信息*/
      researchForm: {
        product:'',
        technicalLevel:'',
        workers:'',
        junior_education:'',
        undergraduate:'',
        master:'',
        doctor:'',
        senior:'',
        intermediate:'',
        primary:'',
        foreignNationality:'',
        areaCovered:'',
        artisanTotal:'',
      },
      technicalLevelList:['国际领先','国内领先','行业领先','地区领先'],
      researchRules: {
        product:[
          {required: true, validator: PositiveInteger, trigger: 'blur'}
        ],
        technicalLevel:[
          {required: true, message: '请选择企业产品技术水平', trigger: 'change'}
        ],
        workers:[
          {required: true, validator: PositiveInteger2, trigger: 'blur'}
        ],
        junior_education:[
          {required: true, validator: PositiveInteger3, trigger: 'blur'}
        ],
        undergraduate:[
          {required: true, validator: PositiveInteger4, trigger: 'blur'}
        ],
        master:[
          {required: true, validator: PositiveInteger5, trigger: 'blur'}
        ],
        doctor:[
          {required: true, validator: PositiveInteger11, trigger: 'blur'}
        ],
        senior:[
          {required: true, validator: PositiveInteger6, trigger: 'blur'}
        ],
        intermediate:[
          {required: true, validator: PositiveInteger7, trigger: 'blur'}
        ],
        primary:[
          {required: true, validator: PositiveInteger8, trigger: 'blur'}
        ],
        foreignNationality:[
          {required: true, validator: PositiveInteger9, trigger: 'blur'}
        ],
        areaCovered:[
          {required: true, validator: PositiveFloat, trigger: 'blur'}
        ],
        artisanTotal:[
          {required: true, validator: PositiveInteger10, trigger: 'blur'}
        ],
      },
      /*技术成果信息*/
      technologicalForm:{
        patent_size:'',
        patent_total:'',
        trademark_size:'',
        softening_size:'',
        revenue:'',
        municipal_level:'',
        nationalLevel:''
      },
      technologicalRules:{
        patent_size:[
          {required: true, validator: PositiveInteger12, trigger: 'blur'}
        ],
        patent_total:[
          {required: true, validator: PositiveInteger13, trigger: 'blur'}
        ],
        softening_size:[
          {required: true, validator: PositiveInteger14, trigger: 'blur'}
        ],
        trademark_size:[
          {required: true, validator: PositiveInteger15, trigger: 'blur'}
        ],
        revenue:[
          {validator: checkMoney5, trigger: 'blur'}
        ],
        municipal_level:[
          {required: true, validator: PositiveInteger16, trigger: 'blur'}
        ],
        nationalLevel:[
          {required: true, validator: PositiveInteger17, trigger: 'blur'}
        ],
      },
    }
  },
  methods:{
    /*获取登记注册类型*/
    getRegistrationType() {
      pyfdAppRegistrationType().then(res => {
        if (res.code == 200) {
          this.registerTypeItem = res.content.list;
        }
      })
    },
    /*获取行业分类*/
    getOutsourcingIndustryList() {
      pyfdAppOperatingIndustry().then(res => {
        if (res.code == 200) {
          for (let list of res.content.list) {
            let item = {value: list.categoryName, label: list.categoryName, children: []};
            if (list.smesIndustryAppList) {
              for (let son of list.smesIndustryAppList) {
                let son_list = {pid: son.category, value: son.categoryName, label: son.categoryName}
                item.children.push(son_list);
              }
            }
            this.industryList.push(item);
          }
        }
      })
    },
    /*监听单位所在地修改*/
    handleChange(val) {
      for (let city of this.provincialCode) {
        if (val[0] == city.value) {
          this.basicForm.provinceName = city.label;
          this.basicForm.province = city.value;
          for (let sub of city.children) {
            if (val[1] == sub.value) {
              this.basicForm.cityName = sub.label;
              this.basicForm.city = sub.value;
              for (let district of sub.children) {
                if (val[2] == district.value) {
                  this.basicForm.districtName = district.label;
                  this.basicForm.district = district.value;
                }
              }
            }
          }
        }
      }
    },
    /*提交基本信息进行下一步填写*/
    submitBasic(){
      let can = 0;
      for (let a = 0; a < 5; a++) {
        this.$refs['basicForm'+a].validate((valid) => {
          if (valid) {} else {
            can++;
            return false;
          }
        });
      }
      if (can==0){
        this.activeName='second';
        this.leave=1;
      }
    },
    /*回到上一步填写信息*/
    prevStep(state){
      if (state==1){
        this.activeName='first';
        this.leave=1;
      }else if (state==2){
        this.activeName='second';
        this.leave=2;
      }else if (state==3){
        this.activeName='third';
        this.leave=3;
      }
    },
    /*保存经营信息进入下一步填写*/
    submitBusiness(){
      this.$refs.businessForm.validate((valid) => {
        if (valid) {
          this.activeName='third';
          this.leave=2;
        } else {
          return false;
        }
      });
    },
    /*保存经营信息进入下一步填写*/
    submitResearch(){
      let can = 0;
      for (let a = 0; a < 8; a++) {
        this.$refs['researchForm'+a].validate((valid) => {
          if (valid) {} else {
            can++;
            return false;
          }
        });
      }
      if (can==0){
        this.activeName='fourth';
        this.leave=3;
      }
    },
    /*保存技术成果信息进入保存所有编写数据步骤*/
    submitTechnological(){
      this.$refs.technologicalForm.validate((valid) => {
        if (valid) {
          let formData={
            validPatentsNum:this.technologicalForm.patent_size,
            patentsProductsNum:this.technologicalForm.patent_total,
            validSoftNum:this.technologicalForm.softening_size,
            validTrademarkNum:this.technologicalForm.trademark_size,
            patentsAnnualSalesRevenue:this.technologicalForm.revenue,
            nationalTechnicalAchievements:this.technologicalForm.municipal_level,
            provinceTechnicalAchievements:this.technologicalForm.nationalLevel,
            companyName:this.basicForm.companyName,
            unifiedScCode:this.basicForm.unifiedSocialCreditCode,
            legalPerson:this.basicForm.legalPerson,
            corporatePhone:this.basicForm.legalPhone,
            registrationType:this.basicForm.registerType,
            operatingIndustry:this.basicForm.industry.join('-'),
            registrationTime:this.basicForm.registerTime,
            unitLocation:this.basicForm.provinceName+'-'+this.basicForm.cityName+'-'+this.basicForm.districtName,
            unitDetailsAddress:this.basicForm.specificAddress,
            holdingSituation:this.basicForm.hold,
            contactPerson:this.basicForm.contactPerson,
            contactPersonPhone:this.basicForm.contactPersonPhone,
            officePhone:this.basicForm.contactOfficePhone,
            registeredCapital:this.basicForm.registerMoney,
            xmsbUserId:this.cid!=0 ? this.cid : '',
            systemType:this.systemType,
            cqUnit:this.fillType,
            itemsType:this.fillType,
            lastYearOperatingIncome:this.businessForm.profit,
            totalAnnualTax:this.businessForm.payTaxes,
            totalAssets:this.businessForm.assets,
            totalLiabilities:this.businessForm.liabilities,
            newProductSalesRevenue:this.businessForm.sellIncome,
            isHightechEnterprises:this.businessForm.highTechEnterprise,
            enterpriseProductTechnologyLevel:this.researchForm.technicalLevel,
            rdProductsNum:this.researchForm.product,
            enterpriseSize:this.researchForm.workers,
            collegeDegreeAboveNum:this.researchForm.junior_education,
            undergraduateNum:this.researchForm.undergraduate,
            masterDegreeNum:this.researchForm.master,
            phdNum:this.researchForm.doctor,
            rdSeniorTitleNum:this.researchForm.senior,
            rdMiddleTitleNum:this.researchForm.intermediate,
            rdPrimaryTitleNum:this.researchForm.primary,
            foreignNationalityNum:this.researchForm.foreignNationality,
            rdPersonnelNum:this.researchForm.artisanTotal,
            rdFacilityArea:this.researchForm.areaCovered
          }
          pyfdAppKeyPolicyWarehousing({smesWhitelist:JSON.stringify(formData),request:'form'}).then(res=>{
            if (res.code==200){
              this.$message.success(res.msg);
              this.$router.replace({
                path: '/cultivation/index',
                query: {
                  city: this.childNode.cityCode,
                  cityName: this.childNode.name,
                  pName:this.childNode.name+'企业数字化服务云平台',
                }
              })
            }
          })
        } else {
          return false;
        }
      });
    }
  },
  mounted() {
    this.getRegistrationType();
    this.inputWidth = ((this.$refs.basicForm0.$el.clientWidth - 500) / 2);
  },
  beforeMount() {
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
    this.pName = this.$route.query.pName;
    this.fillType=this.$route.query.type;
    this.systemType=this.$route.query.systemType;
    if (sessionStorage.getItem('childNode')) {
      this.childNode = JSON.parse(sessionStorage.getItem('childNode'));
    }
    this.getOutsourcingIndustryList();
  }
}
</script>
<style scoped>
.fill-container >>> .fill-content .fill-breadcrumb .el-breadcrumb__separator[class*=icon] {
  margin: 0 0px;
  font-family: 'SourceHanSansCN';
  color: #5D5D5D;
}
.fill-container >>> .fill-content .fill-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner,
.fill-container >>> .fill-content .fill-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.fill-container >>> .fill-content .fill-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.fill-container >>> .fill-content .fill-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 100;
  color: #5D5D5D;
  font-family: 'SourceHanSansCN';
}
.fill-container >>> .fill-content .fill-breadcrumb .el-breadcrumb {
  font-size: 14px;
  line-height: normal;
}
.fill-container >>> .fill-content .fill-breadcrumb .el-breadcrumb__inner a,
.fill-container >>> .fill-content .fill-breadcrumb .el-breadcrumb__inner.is-link {
  font-weight: 100;
  color: #333333;
}
.fill-container >>> .fill-content .fill-info .el-tabs--card>.el-tabs__header {
  border-bottom: 1px solid #DDDDDD;
  padding: 0px 18% 15px;
  min-width: 76rem;
  background: #ffffff;
  margin: 0 0 0px;
}
.fill-container >>> .fill-content .fill-info .el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
  border-bottom-color: #FFF;
  background: #1637FF;
  color: #ffffff;
  font-size: 18px;
}
.fill-container >>> .fill-content .fill-info .el-tabs__item {
  padding: 10px 20px;
  height: auto;
  line-height: normal;
  font-size: 18px;
  font-weight: 100;
  font-family: 'SourceHanSansCN';
  color: #333333;
  border-left: none;
}
.fill-container >>> .fill-content .fill-info .el-tabs--card>.el-tabs__header .el-tabs__nav {
  border: none;
  border-radius: 0px;
}

.fill-container >>> .fill-content .fill-info .fill-form .basic-form-container .basicForm0 .demo-form-inline {
  display: flex;
  justify-content: space-between;
}
.fill-container >>> .fill-content .fill-info .fill-form .el-button--primary {
  color: #FFF;
  background-color: #1637FF;
  border-color: #1637FF;
  padding: 15px 100px;
  margin-top: 35px;
  font-size: 18px;
  font-family: 'SourceHanSansCN';
}
.fill-container >>> .fill-content .fill-info .fill-form .el-button--danger {
  color: #FFF;
  background-color: #FE273B;
  border-color: #FE273B;
  padding: 15px 100px;
  margin-top: 35px;
  font-size: 18px;
  font-family: 'SourceHanSansCN';
}
</style>
<style scoped lang="scss">
.fill-container {
  background: #F2F3FB;
  .fill-content {
    .fill-breadcrumb {
      display: flex;
      justify-content: left;
      font-size: 14px;
      font-weight: 100;
      color: #333333;
      font-family: "SourceHanSansCN";
      padding: 10px 18%;
      min-width: 76rem;
      background: #F2F3FB;
    }
    .fill-info {
      background: #ffffff;
      min-width: 76rem;
      .fill-title {
        font-size: 24px;
        font-family: "SourceHanSansCN";
        color: #333333;
        margin-block-start: 0px;
        cursor: pointer;
        padding: 30px 18% 1em;
        background: #ffffff;
        min-width: 76rem;
        margin-block-end: 0px;
      }
      .fill-form{
        padding: 30px 18% 0px;
        min-width: 76rem;
        background: white;
        .is-red-label{
          font-size: 14px;
          color: #fe273b;
        }
      }
    }
  }
}
</style>